import {
  Banknote,
  CalendarClock,
  CircleCheck,
  Clock,
  Gauge,
  Info,
  MapPin,
  Percent,
  Receipt,
  Scale,
  ShieldCheck,
  Tag,
  UserCheck,
  type LucideIcon,
} from "lucide-react-native";
import type { FinancialClaimKind } from "@src/packages/costs/financialContent";

/** The icon in front of a financial claim's label, by what the claim is about. */
export const FINANCIAL_CLAIM_ICONS: Record<FinancialClaimKind, LucideIcon> = {
  summary: Info,
  promotion: Tag,
  apr: Percent,
  "loan-maximum": Banknote,
  fee: Receipt,
  term: CalendarClock,
  "credit-check": ShieldCheck,
  eligibility: UserCheck,
  availability: MapPin,
  "qualifying-expense": CircleCheck,
  threshold: Gauge,
  timing: Clock,
  "account-rule": Scale,
};
